import AscHeading from "../AscTypography/AscHeading/AscHeading";
import AscLink from "../AscLink/AscLink";
import Mastercard from "../../assets/images/mastercard.png";

import classNames from "classnames";
import styles from "./AscPaymentMethods.module.scss";
import AscImage from "../AscImage/AscImage";
import { capitalize } from "lodash";

type AscPaymentMethodsSize = "default" | "small";

export interface AscPaymentMethodsProps {
  className?: string;
  size?: AscPaymentMethodsSize;
  data?: {
    id: string;
    brand: string;
    last4: string;
    expMonth: number;
    expYear: number;
    isActive: boolean;
  };
  handleRemove?: (id: string) => void;
}

export function cardHide(card: string) {
  const hideNum = [];
  for (let i = 0; i < card.length; i++) {
    if (i < card.length - 4) {
      hideNum.push("*");
    } else {
      hideNum.push(card[i]);
    }
  }
  return hideNum.join("");
}

export default function AscPaymentMethods({
  className,
  size,
  data,
  handleRemove,
}: AscPaymentMethodsProps) {
  return (
    <div
      data-testid="asc-payment-methods"
      className={classNames(
        styles.ground,
        { [styles.small]: size === "small" },
        className
      )}
    >
      <div className={styles.leftSection}>
        <AscImage src={Mastercard} alt={"Mastercard"} className={styles.photo} />

        <AscHeading
          className={classNames(styles.cardName, styles.text)}
          level={6}
        >
          {capitalize(data?.brand) || "Mastercard"}
        </AscHeading>

        <AscHeading
          className={classNames(styles.cardNumber, styles.text)}
          level={6}
        >
          {cardHide(`************${data?.last4}` || "4242424242424242")}
        </AscHeading>
      </div>

      {size !== "small" && (
        <div className={styles.rightSection}>
          <AscHeading
            className={classNames(styles.cardExpDate, styles.text)}
            level={6}
          >
            {`${data?.expMonth || "20"}/${data?.expYear || 2025}`}
          </AscHeading>

          <AscLink
            onClick={() => data?.id && handleRemove?.(data?.id)}
            className={styles.link}
          >
            Remove
          </AscLink>
        </div>
      )}
    </div>
  );
}
